import React, {Component} from 'react';
import S from 'StyledAccountResponsibleGame.js';
import ResponsibleGamingForm from 'ResponsibleGamingForm.js';
import AccountResponsibleGameSelfExclusion from 'AccountResponsibleGameSelfExclusion.js';
import CmsPage from 'CmsPage.js';
import {translation} from 'helpers/utilsHelper.js';
import ResponsibleLimitsTable from 'ResponsibleLimitsTable.js'

const tabs = [
    { label: 'account_responsibleGame_responsibleGameTab', value: 1 },
    { label: 'account_responsibleGame_limitsTab', value: 2 },
    { label: 'account_responsibleGame_selfExclusionTab', value: 3 }
  ]

class AccountResponsibleGame extends Component {
    constructor(props) {
        super(props);
        this.state = { activeTab: 1 };
      }
    handleClickOnTab = tabId => {
        this.setState({
            activeTab: tabId,
        })
    }

    render() {
        const { activeTab } = this.state;

        return (
            <S.AccountResponsibleGame>
                <S.Header>
                    <S.Title>{translation('account_responsibleGame_title')}</S.Title>
                </S.Header>

                <S.AccountResponsibleGameTabs>
                    <S.TabsWrapper>
                        {tabs.map(({ label, value }, index) => {
                            return (
                                <S.Tab key={index} className={`tab ${value === activeTab ? 'active-tab' : ''}`} onClick={() => {this.handleClickOnTab(value)}}>{translation(label)}</S.Tab>
                            )
                        })}
                    </S.TabsWrapper>
                </S.AccountResponsibleGameTabs>

                {
                activeTab === 1 ? <S.CmsContainer><CmsPage name="graj-odpowiedzialnie-test" isPlaces={true}/></S.CmsContainer> :
                activeTab === 2 ? 
                    <>
                        <ResponsibleLimitsTable/>
                        <ResponsibleGamingForm accountView/> 
                    </> : 
                activeTab === 3 ? <AccountResponsibleGameSelfExclusion/> : null 
                }

            </S.AccountResponsibleGame>
        );
    }
}

export default AccountResponsibleGame;
